<template>
  <b-row class="dashboard-indicadores-historico-objetivos-mensuales">
    <b-col cols="12">
      <label class="titulo">Objetivos Mensuales</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="objetivosMensuales" 
          :fields="objetivosMensualesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(periodo)="data">
          {{ data.item.periodo | periodo }}
        </template>
        <!-- <template v-slot:cell(pjeObjetivoVentas)>
        </template> -->
        <template v-slot:cell(objetivoVentas)="data">
          {{ data.item.objetivoVentas | moneda }}
        </template>
        <template v-slot:cell(objetivoRentabilidadBruta)="data">
          {{ data.item.objetivoRentabilidadBruta | porcentaje }}
        </template>
        <template v-slot:cell(importeFacturar)="data">
          {{ data.item.importeFacturar | moneda }}
        </template>
        <template v-slot:cell(importeFacturado)="data">
          {{ data.item.importeFacturado | moneda }}
        </template>
        <template v-slot:cell(rentabilidadBrutaEstimada)="data">
          {{ data.item.rentabilidadBrutaEstimada | porcentaje }}
        </template>
        <template v-slot:cell(rentabilidadBrutaReal)="data">
          {{ data.item.rentabilidadBrutaReal | porcentaje }}
        </template>

        <template v-slot:cell(progreso)="data">
          <div class="indicadores">
            <chart-pje-objetivo-ventas descripcion="" :pjeActual="data.item.pjeActualObjetivoVentas" />
            <chart-pje-objetivo-rentabilidad-bruta descripcion="" :pjeActual="data.item.pjeActualObjetivoRentabilidadBruta" />
          </div>
        </template>

        <template v-slot:cell(opciones)="data">
          <template>
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item @click.stop="exportarFacturacionEstimadaClientes(data.item)">
                <i class="fa fa-file-excel-o"></i>Exportar Facturación Estimada</b-dropdown-item>
              <b-dropdown-item @click.stop="exportarPresupuestosRentabilidadBrutaEstimadaPeriodo(data.item)">
                <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Estimada</b-dropdown-item>
              <b-dropdown-item
                  @click.stop="exportarPresupuestosRentabilidadBrutaRealPeriodo(data.item)">
                <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Real</b-dropdown-item>
              <b-dropdown-item @click.stop="exportarVentasPeriodo(data.item)">
                <i class="fa fa-file-excel-o"></i>Exportar Ventas</b-dropdown-item>
            </b-dropdown>
          </template>
        </template>

      </b-table>
    </b-col>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </b-row>
</template>

<script>
import ChartPjeObjetivoVentas from '../ChartPjeObjetivo.vue';
import ChartPjeObjetivoRentabilidadBruta from '../ChartPjeObjetivo.vue';
import ChartPjeObjetivoRentabilidadBrutaEstimada from '../ChartPjeObjetivo.vue';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    ChartPjeObjetivoVentas,
    ChartPjeObjetivoRentabilidadBruta,
    ChartPjeObjetivoRentabilidadBrutaEstimada,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data() {
    return {
      key: 0,
      tableBusy: false,

      objetivosMensuales: [],
      objetivosMensualesFields: [],
    }
  },
  created() {

    this.objetivosMensualesFields = [
      { key: 'periodo' },
      { 
        key: 'objetivoVentas',
        label: 'Obj. Ventas',
        class: 'text-right'
      },
      { 
        key: 'objetivoRentabilidadBruta',
        label: 'Obj. RB',
        class: 'text-right'
      },
      { 
        key: 'importeFacturar',
        label: 'Facturar',
        class: 'text-right'
      },
      { 
        key: 'importeFacturado',
        label: 'Facturado',
        class: 'text-right'
      },
      { 
        key: 'rentabilidadBrutaEstimada',
        label: 'RB Est.',
        class: 'text-right'
      },
      { 
        key: 'rentabilidadBrutaReal',
        label: 'RB Real',
        class: 'text-right'
      },
      { 
        key: 'progreso',
        label: 'Progreso Vtas / RB',
        class: 'text-center'
      },
      { 
        key: 'opciones',
        label: '',
        class: 'text-center'
      }
    ];
  },
  computed: {
    objetivosMensualesFromStore() {
      return this.$store.getters['resultadosComercial/objetivosMensualesHistoricos'];
    }
  },  
  methods: {
    getResultados() {
      this.tableBusy = true;
      this.$store.dispatch('resultadosComercial/getObjetivosMensualesHistoricos')
        .then(() => {
          this.objetivosMensuales = this.$store.getters['resultadosComercial/objetivosMensualesHistoricos'];
        })
        .finally(() => this.tableBusy = false);
    },
    // loadGrilla() {
    //   this.objetivosMensuales = cloneDeep(this.$store.getters['resultadosComercial/objetivosMensuales']);
    // },
    exportarPresupuestosRentabilidadBrutaEstimada(item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaEstimada', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Estimada';
            let fileName = 'resumen-rentabilidad-bruta-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaReal(item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }

      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaReal', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Real';
            let fileName = 'resumen-rentabilidad-bruta-real';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasCliente (item) {
      let params = {
        clienteId: item.clienteId,
        fechaDesde: moment(item.periodo).format('YYYY-MM-DD'),
        fechaHasta: moment(item.periodo).add(1, 'months').add(-1, 'days').format('YYYY-MM-DD'),
      }

      // console.log(item.periodo, new Date(item.periodo), new Date(item.periodo).toISOString())

      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getRptVentaMensualCliente', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosVentas/resultados'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas-cliente';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];
            // if ((/true/i).test(params.discriminarReembolsos)) {
            //   format.push({ titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            // }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaEstimadaPeriodo(item) {
      console.log(item);
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaEstimada', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Estimada';
            let fileName = 'resumen-rentabilidad-bruta-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaRealPeriodo(item) {
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }

      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaReal', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Real';
            let fileName = 'resumen-rentabilidad-bruta-real';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasPeriodo (item) {
      let params = {
        clienteId: 0,
        fechaDesde: moment(item.periodo).format('YYYY-MM-DD'),
        fechaHasta: moment(item.periodo).add(1, 'months').add(-1, 'days').format('YYYY-MM-DD'),
      }

      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getRptVentaMensualCliente', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosVentas/resultados'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas-periodo';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];
            // if ((/true/i).test(params.discriminarReembolsos)) {
            //   format.push({ titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            // }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    exportarFacturacionEstimadaCliente (item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }
      this.exportarFacturacionEstimada(params);
    },
    exportarFacturacionEstimadaClientes(item) {
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }
      this.exportarFacturacionEstimada(params);
    },
    exportarFacturacionEstimada (params) {
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getFacturacionEstimada', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let facturacionEstimada = this.$store.getters['resultadosComercial/resultados'];

          if (facturacionEstimada) {
            if (facturacionEstimada.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Facturacion Estimada';
            let fileName = 'facturacion-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Acción', nombre: 'accion', formato: '' },
              { titulo: 'Fact.Estimada', nombre: 'importe', formato: '' },
              { titulo: 'Facturado', nombre: 'importeFacturado', formato: '' },
              { titulo: 'Saldo', nombre: 'saldo', formato: '' },
            ];

            this.exportXLS(title, fileName, facturacionEstimada, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

  },
  watch: {
    objetivosMensualesFromStore: {
      handler(newValue) {
        this.objetivosMensuales = cloneDeep(newValue);
      },
      immediate: true,
      deep: true
    }
  },  
}
</script>

<style>
  .dashboard-indicadores-historico-objetivos-mensuales .registro table {
    position: relative;
    /* top: 20px; */
  }
  /* .dashboard-indicadores-historico-objetivos-mensuales .registro table thead th {
    border-top: none;
  } */
  .dashboard-indicadores-historico-objetivos-mensuales .registro table tbody tr td {
    padding-top: 10px;
    padding-bottom: 5px;
    vertical-align: top;
  }

  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="1"] {
    width: calc(25% - 160px) !important;
  }
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="2"],
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="4"],
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="5"] {
    width: 15% !important;
  }
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="6"],
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="7"] {
    width: 10% !important;
  }
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="8"] {
    /* width: 14%; */
    /* width: calc(8% - 20px); */
    width: 130px !important;
  }
  .dashboard-indicadores-historico-objetivos-mensuales .registro table td[aria-colindex="9"] {
    width: 30px !important;
    padding-left: 5px;
    padding-right: 5px;
  }


  .dashboard-indicadores-historico-objetivos-mensuales .chart-pje-objetivo {
    /* margin-top: 0; */
    margin-bottom: 5px;
  }
</style>


